"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _FormActions = require("../../actions/FormActions");
var Helpers = _interopRequireWildcard(require("../../utils/helper"));
var _ReduxForm = require("../../utils/ReduxForm.Functions");
var Validation = _interopRequireWildcard(require("../../utils/validation.helper"));
var _BrixelButtonPrimary = _interopRequireDefault(require("../BrixelButtonPrimary"));
var _BrixelCheckbox = _interopRequireDefault(require("./BrixelCheckbox"));
var _BrixelInputText = _interopRequireDefault(require("./BrixelInputText"));
var _ReduxField = _interopRequireDefault(require("./ReduxField"));
var _translation = _interopRequireDefault(require("../../Translation/translation"));
var _BrixelInputPhone = _interopRequireDefault(require("./BrixelInputPhone"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelRegister = props => {
  const {
    baseURL = '',
    disableEmailRegister = false,
    changeFieldValue,
    company,
    enableMultiple = false,
    errorValue = {},
    formName = 'register',
    formValue = {},
    isSimpleForm = false,
    lang = 'en',
    pageType,
    section = null,
    showErrors = false,
    showGeneratePassword = true,
    skipPhone = false,
    translations,
    validateEmail = false,
    isBuyer
  } = props;
  // STATE
  const [showPassword, setShowPassword] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const splittedName = (0, _get.default)(formValue, 'register.name', ' ') ? (0, _get.default)(formValue, 'register.name', ' ').split(' ') : [];
    const firstName = splittedName[0] || (0, _get.default)(formValue, 'register.name', '');
    let lastName = splittedName[1] || '';
    splittedName.forEach((name, i) => {
      if (i > 1) lastName += ` ${name}`;
    });
    lastName = typeof lastName === 'undefined' ? '' : lastName;
    changeFieldValue(formName, 'register.firstName', firstName);
    changeFieldValue(formName, 'register.lastName', lastName);
  }, [(0, _get.default)(formValue, 'register.name', null)]);
  const generatePassword = () => {
    const retVal = Helpers.generatePassword();
    changeFieldValue(formName, 'register.password', retVal);
    setShowPassword(true);
  };
  const policyBaloise = `<span class="mb-1 dis-b fsize-300">${(0, _translation.default)('I agree that my data may be transmitted to Baloise Insurance Ltd, Baloise Life Ltd and Baloise Bank Ltd for the purpose of checking my entitlement to a discount and the information that I use the Brixel service for the purpose of evaluating and optimising the service and in order to be able to meet my requirements.', lang, undefined, translations)}</span>`;
  const policyBaloiseBuyer = `<span class="mb-1 dis-b fsize-300">${(0, _translation.default)('I agree that my data may be transmitted to Baloise Insurance Ltd, Baloise Life Ltd and Baloise Bank Ltd for the purpose of contacting me for consultation as well as the information that I use the Brixel service for the purpose of evaluating and optimising the service.', lang, undefined, translations)}</span>`;
  const termsBaloise = `<p class="mb-1 fsize-300">${(0, _translation.default)('I agree that my data (surname, first name, telephone number, email) may be transmitted to Baloise Insurance Ltd, Baloise Bank Ltd and Baloise Life Ltd for the purpose of checking my entitlement to a discount by comparing it with my relevant data held by Baloise Insurance Ltd and/or Baloise Life Ltd and/or Baloise Bank Ltd as well as the information that I use the Brixel service for the purpose of evaluating and optimising the service and in order to be able to better meet my requirements.', lang, undefined, translations)}</p>

<p class="fsize-300">${(0, _translation.default)('This consent can be revoked at any time for the future. If you revoke your consent this does not affect the lawfulness of the data processing undertaken on the basis of your consent up until the revocation.', lang, undefined, translations)}`;
  const termsBaloiseBuyer = `<p class="mb-1 fsize-300">${(0, _translation.default)('I agree that my data (surname, first name, telephone number, email) may be transmitted to Baloise Insurance Ltd, Baloise Life Ltd and Baloise Bank Ltd for the purpose of contacting me for consultation on home financing including risk protection as well as the information that I use the Brixel service for the purpose of evaluating and optimising the service.', lang, undefined, translations)}</p>

<p class="fsize-300">${(0, _translation.default)('This consent can be revoked at any time for the future. If you revoke your consent this does not affect the lawfulness of the data processing undertaken on the basis of your consent up until the revocation.', lang, undefined, translations)}`;
  const termsUbs = `
                    <p class="mb-1 fsize-300">${(0, _translation.default)('I agree that my data (name, first name, phone number, email) may be transmitted to UBS Switzerland AG (hereinafter UBS) for the following purposes:', lang, undefined, translations)}</p>
                    <ul class="ml-1 mb-1">
                        <li class="fsize-300">${(0, _translation.default)('Reporting; This gives UBS insight into the status assigned to my sales object by Brixel (e.g. “registered,” “reserved,” “sold”);', lang, undefined, translations)}</li>
                        <li class="fsize-300">${(0, _translation.default)('UBS offers: UBS may contact me to present offers for financial services and advice related to my property, including non-binding market value estimates and similar services.', lang, undefined, translations)}</li>
                    </ul>
                    <p class="mb-1 fsize-300">${(0, _translation.default)('This consent can be revoked at any time, with the revocation only taking effect for the future. Data processing that occurred before the revocation is not affected by it.', lang, undefined, translations)}</p>
                    <p class="fsize-300 dis-f flex-wrap">${(0, _translation.default)('Further information about the processing and protection of your data by UBS, your rights concerning your data, as well as the contact details of the Group DP Office can be found in the <a href="{{0}}" class="mr-small-4" target="_blank">UBS Privacy Notice.</a>', lang, [`https://www.ubs.com/global/${lang}/legal/privacy.html`], translations)}
                    `;
  const termsUbsBuyer = `<p class="mb-1 fsize-300">${(0, _translation.default)('UBS\'s financing offers are only available to Swiss residents.', lang, undefined, translations)}</p>

<p class="mb-1 fsize-300">${(0, _translation.default)('I agree that my data (surname, first name, address, postal code, telephone number, e-mail address) is transmitted to UBS for reporting and advisory purposes. UBS will have access to the status assigned by Brixel for the properties that I am interested in (e.g. "interested", "reserved", "purchased"). UBS may also contact me for advisory purposes. This consent can be revoked at any time, it being understood that such revocation may only be effective for the future. The revocation does not affect any data processing carried out prior to such revocation.', lang, undefined, translations)}</p>

<p class="fsize-300 dis-f flex-wrap">${(0, _translation.default)('For more information about how UBS processes your data including how UBS protects your data, your rights in respect of your data and contact details of the Group DP Office, please refer to the <a href="{{0}}" class="mr-small-4" target="_blank">Privacy Notice</a> of UBS.', lang, [`https://www.ubs.com/global/${lang}/legal/privacy.html`], translations)}`;
  const brixelTerms = ` <span class="policyText fsize-300">${(0, _translation.default)('I hereby confirm that I have read, understand and accept the <a href="{{0}}" target="_blank">terms</a> and <a href="{{1}}" target="_blank">privacy policy</a> of Brixel.', lang, [`https://brixel.ch/${lang}/agb-nutzungsbedingungen/`, `https://brixel.ch/${lang}/datenschutzrichtlinien/`], translations)}</span>`;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, section !== 'admin' && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    disableAutocomplete: true,
    fieldNum: 5,
    input: {
      disableDelay: false,
      disableAutocomplete: true,
      name: 'register.name',
      placeholder: pageType === 'boutique' ? (0, _translation.default)('Full Name', lang, undefined, translations) : (0, _translation.default)('Your Full Name', lang, undefined, translations),
      type: 'text',
      validate: [Validation.required],
      disabled: (0, _get.default)(formValue, 'owner', null) !== null
    },
    labels: {
      label: (0, _translation.default)('Full Name', lang, undefined, translations)
    },
    design: {
      className: 'mt-2 w-perc-100',
      large: true
    },
    form: formName,
    component: _BrixelInputText.default,
    meta: {
      dirty: (0, _get.default)(formValue, 'register.name', false) || showErrors,
      invalid: (0, _get.default)(errorValue, 'register.name', true) !== true,
      message: {
        error: (0, _translation.default)('Please insert a valid name', lang, undefined, translations)
      },
      showErrors
    }
  }))), /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    baseURL: baseURL,
    multiple: enableMultiple,
    fieldNum: 5,
    input: {
      disableDelay: false,
      disableAutocomplete: true,
      name: 'register.email',
      placeholder: 'example@brixel.io',
      type: 'email',
      validate: [Validation.isEmail, Validation.required],
      disabled: disableEmailRegister || (0, _get.default)(formValue, 'owner', null) !== null,
      validateEmail
    },
    labels: {
      label: (0, _translation.default)('Email address', lang, undefined, translations)
    },
    design: {
      className: section !== 'admin' ? 'mt-2' : '',
      large: true
    },
    form: formName,
    component: _BrixelInputText.default,
    meta: {
      dirty: (0, _get.default)(formValue, 'register.email', null) || showErrors,
      invalid: (0, _get.default)(errorValue, 'register.email', true) !== true,
      message: {
        error: (0, _translation.default)('Please insert a valid email', lang, undefined, translations)
      },
      showErrors
    }
  }), /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    multiple: enableMultiple,
    fieldNum: 5,
    form: formName,
    design: {
      className: 'mt-2',
      large: true
    },
    input: {
      disableAutocomplete: true,
      name: 'register.phone',
      placeholder: '',
      disabled: (0, _get.default)(formValue, 'owner', null) !== null,
      validate: skipPhone ? [] : [Validation.phoneIfNotEmptyLength, Validation.required]
    },
    labels: {
      label: (0, _translation.default)('Phone number', lang, undefined, translations)
    },
    component: _BrixelInputPhone.default,
    meta: {
      dirty: skipPhone ? false : (0, _get.default)(formValue, 'register.phone', null) || showErrors,
      invalid: skipPhone ? false : (0, _get.default)(errorValue, 'register.phone', true) !== true,
      message: {
        error: (0, _translation.default)(skipPhone ? '' : 'Please insert a valid phone', lang, undefined, translations)
      },
      showErrors: skipPhone ? false : showErrors
    }
  }), (0, _get.default)(formValue, 'owner', null) === null && !isSimpleForm && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f jc-b mt-2"
  }, /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    ReduxFieldClass: "flex-1",
    multiple: enableMultiple,
    fieldNum: 5,
    input: {
      disableDelay: false,
      disableAutocomplete: true,
      name: 'register.password',
      placeholder: '',
      type: 'password',
      validate: [Validation.minLength(5), Validation.required],
      disabled: (0, _get.default)(formValue, 'owner', null) !== null
    },
    labels: {
      label: (0, _translation.default)('Password', lang, undefined, translations)
    },
    design: {
      className: `w-perc-100 ${showGeneratePassword ? 'mr-2' : ''}`,
      showPassword,
      showStrongPassword: true,
      large: true
    },
    form: formName,
    component: _BrixelInputText.default,
    meta: {
      dirty: (0, _get.default)(formValue, 'register.password', showErrors),
      invalid: (0, _get.default)(errorValue, 'register.password', true) !== true,
      message: {
        error: (0, _translation.default)('The password must be at least 5 characters.', lang, undefined, translations)
      },
      showErrors
    }
  }), showGeneratePassword && (/*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    onClick: () => generatePassword(),
    className: "as-fs mt-4",
    label: (0, _translation.default)('Generate', lang, undefined, translations),
    disabled: (0, _get.default)(formValue, 'owner', null) !== null
  })))), section !== 'admin' && !isSimpleForm && (/*#__PURE__*/_react.default.createElement("div", {
    className: "privacyTermsBlock"
  }, /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    fieldNum: 5,
    form: formName,
    component: _BrixelCheckbox.default,
    design: {
      className: 'policyConcent body2 w-perc-100 max-w-perc-100'
    },
    input: {
      disableDelay: false,
      name: 'register.privacy',
      options: [{
        label: brixelTerms,
        value: true
      }],
      validate: [Validation.required]
    },
    meta: {
      dirty: showErrors,
      invalid: errorValue['register.privacy'] !== true && showErrors,
      message: {
        error: (0, _translation.default)('Please accept terms and privacy policy', lang, undefined, translations)
      },
      showErrors
    }
  }), company?.stub === 'ubs' && (/*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    fieldNum: 5,
    form: formName,
    component: _BrixelCheckbox.default,
    design: {
      className: 'policyConcent body2 w-perc-100 max-w-perc-100'
    },
    input: {
      disableDelay: false,
      name: 'register.termsUBS',
      options: [{
        label: `<span class="policyText fsize-300">${(0, _translation.default)('I accept the transmission of my personal data to', lang, undefined, translations)}</span><span class="policyText fsize-300 ml-small-4">UBS.</span>`,
        value: true,
        moreInfoExpand: isBuyer ? termsUbsBuyer : termsUbs
      }]
    },
    meta: {
      dirty: false,
      invalid: false,
      message: {
        error: (0, _translation.default)('Please accept terms and privacy policy', lang, undefined, translations)
      },
      showErrors: false
    }
  })), company?.stub === 'baloise' && (/*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    fieldNum: 5,
    form: formName,
    component: _BrixelCheckbox.default,
    design: {
      className: 'policyConcent body2 w-perc-100 max-w-perc-100'
    },
    input: {
      disableDelay: false,
      name: 'register.termsBaloiseBank',
      onChange: value => changeFieldValue(formName, 'register.termsBaloiseInsurance', value),
      options: [{
        label: isBuyer ? policyBaloiseBuyer : policyBaloise,
        value: true,
        moreInfoExpand: isBuyer ? termsBaloiseBuyer : termsBaloise
      }]
    },
    meta: {
      dirty: false,
      invalid: false,
      message: {
        error: (0, _translation.default)('Please accept terms and privacy policy', lang, undefined, translations)
      },
      showErrors: false
    }
  })), /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    fieldNum: 5,
    form: formName,
    component: _BrixelCheckbox.default,
    design: {
      className: 'policyConcent body2 w-perc-100 max-w-perc-100'
    },
    input: {
      disableDelay: false,
      name: 'register.acceptMarketing',
      options: [{
        label: `<span class="policyText fsize-300">${pageType === 'boutique' ? (0, _translation.default)('Send me occasional news and insights regarding the real estate market.', lang, undefined, translations) : (0, _translation.default)('Send me occasional news and insights about the real estate market.', lang, undefined, translations)}</span>`,
        value: true
      }],
      validate: []
    },
    meta: {
      dirty: false,
      invalid: false,
      message: {
        error: (0, _translation.default)('Please accept the marketing', lang, undefined, translations)
      },
      showErrors: false
    }
  }))));
};
const mapStateToProps = (state, ownProps) => {
  const formName = ownProps.formName || 'register';
  return {
    errorValue: (0, _get.default)(state, `brixelForm[${formName}].syncErrors`, {}),
    formValue: (0, _get.default)(state, `brixelForm[${formName}].values`, {}),
    getAllFormData: (0, _get.default)(state, 'brixelForm', {}),
    translations: (0, _get.default)(state, 'translations', {})
  };
};
const mapDispatchToProps = dispatch => ({
  changeFieldValue(form, field, value) {
    dispatch((0, _ReduxForm.change)(form, field, value));
  },
  handleUpdateErrors: (0, _redux.bindActionCreators)(_FormActions.setErrors, dispatch),
  handleUpdateValues: (0, _redux.bindActionCreators)(_FormActions.setValues, dispatch)
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BrixelRegister);